import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../services/dashboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-term-condition-popup',
  templateUrl: './partner-term-condition-popup.component.html',
  styleUrls: ['./partner-term-condition-popup.component.scss']
})
export class PartnerTermConditionPopupComponent implements OnInit {
  currentState = 0;
  isChecked = false;
  @ViewChild('term_condition__Modal') myModal: any;
  constructor(private dashboardService: DashboardService, private modalService: NgbModal, public router: Router) { }

  ngOnInit(): void {
    const options: NgbModalOptions = {
      backdrop: 'static',   // disables click outside to close
      keyboard: false       // disables ESC key
    };
    // this.modalService.open(this.myModal, options);

  }


  submitAcceptance() {
    let opts = {
      isAccepted: true
    }
    this.dashboardService.acceptTermforInfosys(opts).subscribe(res => {
      window.location.reload()
    }, error => {

    })
    
  }

}
